<template>
    <EmptyState
        description="Adjust your search and try again"
        icon="fa-regular fa-files"
        title="No results found"
    >
        <template #action>
            <DsButton
                size="sm"
                variant="tertiary"
                @click="$emit('clearSearch')"
            >
                Clear search
            </DsButton>
        </template>
    </EmptyState>
</template>

<script setup lang="ts">
import EmptyState from '@/components/shared/EmptyState.vue';
import DsButton from '@ds/button/DsButton.vue';

defineEmits<{
    (event: 'clearSearch'): void;
}>();
</script>
